import type { IconData } from '@stacksjs/iconify-core'

export const door: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M400 464V64H112v400H16v32h480v-32Zm-32 0H144V96h224Z\"/><path fill=\"currentColor\" d=\"M312 252h32v72h-32z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default door
